import React from "react";
import { Helmet } from "react-helmet-async";

export interface QA { q: string; a: string; }
interface Props { items: QA[]; }

const FAQ: React.FC<Props> = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div className="faq" data-testid="faq">
        {items.map((it, i) => (
          <details key={i}>
            <summary>{it.q}</summary>
            <div className="faq-body">{it.a}</div>
          </details>
        ))}
      </div>
    </>
  );
};

export default FAQ;
